import clsx from 'clsx';
import { FC, PropsWithChildren, ReactNode } from 'react';

import { ScrollBox } from '../ScrollBox/ScrollBox';

type Props = {
  headerBar: ReactNode;
};

export const HeaderMenuMobileMenu: FC<PropsWithChildren<Props>> = ({ headerBar, children }) => (
  <>
    <div className="c-se--default relative z-10 h-16">{headerBar}</div>
    {/* Content */}
    <ScrollBox
      className="max-h-[calc(100vh-4rem)] overflow-y-auto border-t py-4"
      classNames={{
        top: [clsx('border-t-bor-neu-mut'), clsx('border-t-bac-tie1')],
      }}
    >
      <div className="c-se--default">{children}</div>
    </ScrollBox>
  </>
);
